"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderKatex = exports.KatexTypesetter = void 0;
const auto_render_1 = __importDefault(require("katex/dist/contrib/auto-render"));
const controls_1 = require("@jupyter-widgets/controls");
let latexDelimiters = [
    { left: '$$', right: '$$', display: true },
    { left: '$', right: '$', display: false },
    { left: '\\(', right: '\\)', display: false },
    { left: '\\[', right: '\\]', display: true }
];
// Override DescriptionView with one that doesn't use MathJax, and instead just uses KatexTypesetter
controls_1.DescriptionView.prototype.typeset = function (element, text) {
    this.displayed.then(() => {
        var _a;
        const widget_manager = this.model.widget_manager;
        const latexTypesetter = (_a = widget_manager._rendermime) === null || _a === void 0 ? void 0 : _a.latexTypesetter;
        if (latexTypesetter) {
            if (text !== void 0) {
                element.textContent = text;
            }
            latexTypesetter.typeset(element);
        }
    });
};
class KatexTypesetter {
    /**
     * Typeset the math in a node.
     */
    typeset(node) {
        (0, auto_render_1.default)(node, {
            delimiters: latexDelimiters
        });
    }
}
exports.KatexTypesetter = KatexTypesetter;
function renderKatex() {
    (0, auto_render_1.default)(document, {
        delimiters: latexDelimiters,
    });
}
exports.renderKatex = renderKatex;
//# sourceMappingURL=katex.js.map